<template>
  <vx-card
    class="mt-3 relative z-999"
    id="busca-descontos"
    title="Filtrar relatório"
    collapseAction
    collapsed
    subtitle="Você pode fazer uma busca e filtrar as informações que precisa."
  >
    <div class="vx-row">
      <vs-col vs-lg="3" vs-md="6" vs-sm="12" class="vx-col mb-4">
        <div class="vx-row">
          <vs-col vs-w="12" class="vx-col">
            <span>Período de criação:</span>
          </vs-col>

          <vs-col vs-w="12" class="vx-col">
            <daterange-input v-model="ranges.criacao" />
          </vs-col>
        </div>
      </vs-col>

      <vs-col vs-w="12" class="vx-col">
        <div class="vx-row">
          <vs-col vs-w="12" class="vx-row">
            <vs-button
              color="#5abfa3"
              type="relief"
              size="small"
              icon-pack="feather"
              icon="icon-search"
              v-on:click="buscar()"
              class="mr-3"
            >Buscar</vs-button>
            <vs-button
              v-if="possuiFiltros"
              color="#5abfa3"
              type="relief"
              size="small"
              icon-pack="feather"
              icon="icon-search"
              v-on:click="limparFiltros()"
            >Limpar Filtros</vs-button>
          </vs-col>
        </div>
      </vs-col>
    </div>
  </vx-card>
</template>


<script>
import DaterangeInput from "@/components/inputs/DaterangeInput.vue";
import moment from "moment";

export default {
  name: "busca-produtividade",
  components: {
    DaterangeInput
  },
  data() {
    return {
      filtro: {},
      ranges: {
        criacao: null
      }
    };
  },
  created() {
    this.setupFiltros({ ...this.$route.query });
  },
  watch: {
    $route(to) {
      this.setupFiltros({ ...to.query });
    }
  },
  computed: {
    possuiFiltros() {
      return Object.values(this.$route.query).length > 0;
    }
  },
  methods: {
    setupFiltros(query) {
      this.filtro = query;

      if (this.$route.query.criacao) {
        let ranges = ["criacao"];

        ranges.map(range => {
          this.ranges[range] = this.$route.query[range]
            .split("...")
            .map(date => {
              return moment(date).format("DD/MM/YYYY");
            });
        });
      }
    },
    buscar() {
      const ranges = ["criacao"];
      ranges.map(select => {
        if (Array.isArray(this.ranges[select])) {
          this.filtro[select] = `${moment(
            this.ranges[select][0],
            "DD/MM/YYYY"
          ).format("YYYY-MM-DD")}...${moment(
            this.ranges[select][1],
            "DD/MM/YYYY"
          ).format("YYYY-MM-DD")}`;
        } else {
          delete this.filtro[select];
        }
      });

      delete this.filtro.page;

      this.$router.push({
        name: "relatorios-produtividade",
        query: { ...this.filtro }
      });
    },
    limparFiltros() {
      this.$router.push({ name: "relatorios-produtividade" });
      this.ranges = {};
    }
  }
};
</script>
